<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveTagTask()" autocomplete="off">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="type_contact">Destinatários</label>
                <select
                  id="type_contact"
                  v-model="task.type_contact"
                  name="type_contact"
                  type="text"
                  class="custom-select"
                  :class="{
                    'is-invalid': submitted && $v.task.type_contact.$error
                  }"
                >
                  <option></option>
                  <option value="guests">Convidados</option>
                  <option value="registered">Inscritos</option>
                </select>
                <div
                  v-if="submitted && !$v.task.type_contact.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div :class="{ 'col-sm-6': task.type_filter, 'col-sm-12': !task.type_filter }">
              <div class="form-group">
                <label for="type_filter">Filtrar</label>
                <select
                  class="custom-select"
                  name="type_filter"
                  v-model="task.type_filter"
                  @change="setFiltertask()"
                >
                  <option value=""></option>
                  <option value="group">Grupo</option>
                  <option value="status">Status</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group" v-if="task.type_filter === 'group'">
                <label for="groups">Grups</label>
                <multiselect tag-placeholder="Selecione uma ou mais grupos" placeholder="Selecione uma ou mais grupos" v-model="task.groups" label="name" track-by="id" :options="groups" :multiple="true"></multiselect>
              </div>
              <div class="form-group" v-if="task.type_filter === 'status'">
                <label for="type">Status</label>
                <multiselect tag-placeholder="Selecione uma ou mais status" placeholder="Selecione uma ou mais status" v-model="task.status" :options="statusSelect" track-by="id" label="name" :multiple="true"></multiselect>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="tags">Tags</label>
                <multiselect tag-placeholder="Selecione ma ou mais tags" placeholder="Selecione uma ou mais tags" v-model="task.tags" label="name" track-by="id" :options="tags" :multiple="true"></multiselect>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Modo de ação</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="action-replace" value="replace" v-model="task.action_mode">
                    <label class="form-check-label" for="action-replace">Substituir tags atuais</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="action-append" value="append" v-model="task.action_mode">
                    <label class="form-check-label" for="action-append">Adicionar às existentes</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveTagTask()">Executar</button>
    </template>
  </b-modal>
</template>
<script>
import Swal from 'sweetalert2'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading,
    Multiselect
  },
  props: {
    idTemplate: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Atualização de Tags',
      loading: true,
      fullPage: true,
      submitted: false,
      task: {
        groups: [],
        status: [],
        action_mode: 'replace'
      },
      status: {},
      modal: false
    }
  },
  validations: {
    task: {
      type_contact: { required }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('taskTag', { postData: 'save' }),
    ...mapActions('template', { getTemplatesAll: 'getAll' }),
    ...mapActions('settings', { GetStatus: 'GetStatusSelect' }),
    ...mapActions('tag', { getAllTags: 'getAll' }),
    ...mapActions('group', { getAllGroups: 'getAll' }),
    getGroups () {
      let params = {
        search: this.search || null,
        status: 1,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAllGroups(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    getTags (filter) {
      let params = {
        search: this.search || null,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAllTags(this.params).then((res) => {
        // this.participants = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    setFilterCampaign () {
      this.task.groups = []
      this.task.status = []
      this.task.tags = []
    },
    deleteTemplate (template) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluido o template: <b>${template.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.delete(template.id)
            successMessage('Sucesso: Template excluído com sucesso.', 2500)
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    loadItem (id) {
      if (id) {
        this.title = 'Editar Status'
        this.getStatusTemplate(id).then((data) => {
          this.task = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      this.getGroups()
      this.getTags()
      this.GetStatus()
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveTagTask () {
      this.submitted = true
      this.$v.task.$touch()
      if (this.$v.task.$invalid) {
        window.scroll(0, 0)
        return
      }

      this.loading = true
      this.task.status = this.task.status ? JSON.stringify(this.task.status) : []
      this.task.groups = this.task.groups ? JSON.stringify(this.task.groups) : []
      this.task.tags = this.task.tags ? JSON.stringify(this.task.tags) : []

      await this.postData(this.task).then(res => {
        let message = 'Sucesso: Ação registrada com sucesso, em minutos as tags serão atualizadas.'
        let delay = 2500
        successMessage(message, delay)
        this.$v.$reset()
        this.loading = false
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.task = { groups: [], status: [], action_mode: 'replace' }
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settings', ['statusSelect']),
    ...mapState('group', ['groups']),
    ...mapState('tag', ['tags']),
    ...mapState('statusTemplate', { data: 'statusTemplate' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
